import React from 'react';
import '../styles/ImageLightbox.css';

const ImageLightbox = ({ imageUrl, isOpen, onClose }) => {
    React.useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        
        if (isOpen) {
            document.addEventListener('keydown', handleKeyDown);
        }
        
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, onClose]);

    if (!isOpen) {
        return null;
    }

    const handleBackdropClick = (e) => {
        // Close only when clicking on the backdrop, not on the image
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="lightbox-backdrop" onClick={handleBackdropClick}>
            <div className="lightbox-content">
                <button className="lightbox-close" onClick={onClose} aria-label="Fechar imagem">
                    <i className="ti-close"></i>
                </button>
                <img src={imageUrl} alt="Produto ampliado" className="lightbox-image" />
            </div>
        </div>
    );
};

export default ImageLightbox;
